import useAppState from '../../../common/state/appState';
import { IVehicleTile } from '../../../types/vehicleTile';
import { MiniHomebase } from './MiniHomebase';
import { removeViewedVehicleItemLocalStorage } from '../../home/utilities/viewedVehiclesTileBuilder';

export const MiniHomebaseContainer = () => {
    const recentlyViewedVehicles = useAppState((state) => state.recentlyViewedVehicles);
    const removeRecentlyViewedVehicle = useAppState((state) => state.removeRecentlyViewedVehicle);

    const updatedViewedTiles = (tileToRemove: IVehicleTile) => {
        removeViewedVehicleItemLocalStorage(tileToRemove);
        removeRecentlyViewedVehicle(tileToRemove.stockNumber);
    };

    return recentlyViewedVehicles.length > 0 ? (
        <>
            <MiniHomebase viewedVehicleTileList={recentlyViewedVehicles} updatedViewedTiles={updatedViewedTiles} />
        </>
    ) : (
        <></>
    );
};
